import _ from 'lodash';
import es from './es.json';

export const getCCAAName = ( country ) => {
  if ( !country ) return null;

  const countryData = _.find( es, { alpha2: country.toLowerCase() } );
  return countryData ? countryData.name : country;
};

export const getCCAA = () => _.map( es, ( item ) => ( {
  id: item.alpha2.toUpperCase(),
  name: item.name,
} ) );

export const isCcaaUE = ( ccaaID ) => '|05|18|19|'.indexOf( `|${ccaaID}|` ) < 0;

